import type { ReactNode } from 'react';

/**
 * RV Anillo pequeño (72) con `consumo` en su tarjeta (§21, como Plan 1.15): el uso hacia un tope, con el número en el centro.
 * Semáforo: gris; amarillo desde el 75 %; rojo al llegar al tope (y la nota lo dice). Se usa en Profesionales (9.6, límite
 * del plan) y Consentimientos (9.11, firmas del mes).
 */
export function TarjetaAnillo({ valor, tope, etiqueta, detalle, nota, children }: { valor: number; tope: number; etiqueta: string; detalle: string; nota: string; children?: ReactNode }) {
    const r = 30;
    const largo = 2 * Math.PI * r;
    const parte = tope <= 0 ? 1 : Math.min(1, valor / tope);
    const color = parte >= 1 ? 'var(--rv-red)' : parte >= 0.75 ? 'var(--rv-warning)' : 'var(--rv-fg-3)';
    return (
        <div className="rv-sv-anillo">
            <div className="rv-sv-anillo__cuerpo">
                <span className="rv-sv-anillo__dibujo" aria-hidden="true">
                    <svg viewBox="0 0 72 72" width="72" height="72">
                        <circle cx="36" cy="36" r={r} fill="none" stroke="var(--rv-paper)" strokeWidth="7" />
                        <circle cx="36" cy="36" r={r} fill="none" stroke={color} strokeWidth="7" strokeLinecap="round" strokeDasharray={`${String(largo * parte)} ${String(largo)}`} transform="rotate(-90 36 36)" />
                    </svg>
                    <strong>{valor}</strong>
                </span>
                <span className="rv-sv-anillo__texto">
                    <strong>{etiqueta}</strong>
                    <span>{detalle}</span>
                    <small>{nota}</small>
                </span>
            </div>
            {children}
        </div>
    );
}
